export default function Submit(props) {
  return (
    <svg 
      width={23} 
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-277.000000, -710.000000)" fill="#FFFFFF" fillRule="nonzero">
          <g transform="translate(243.000000, 672.000000)">
            <path d="M53.5889766,46 L35.8842525,46 C35.3319677,46 34.8842525,45.5522847 34.8842525,45 C34.8842525,44.4477153 35.3319677,44 35.8842525,44 L53.5825962,44 L49.2928932,39.710297 C48.9023689,39.3197727 48.9023689,38.6866077 49.2928932,38.2960834 C49.6834175,37.9055591 50.3165825,37.9055591 50.7071068,38.2960834 L56,43.5889766 C56.7810486,44.3700252 56.7810486,45.6363552 56,46.4174038 L50.7071068,51.710297 C50.3165825,52.1008213 49.6834175,52.1008213 49.2928932,51.710297 C48.9023689,51.3197727 48.9023689,50.6866077 49.2928932,50.2960834 L53.5889766,46 Z" />
          </g>
        </g>
      </g>
    </svg>
  )
}
